module.exports = __webpack_public_path__ + "img/news-1.b426ba13.png";